"use strict";
// These functions are to support the consistency and readability of schema numbers. Their chief role is to reduce the possibility of human error when defining maximum number values for a schema field.
// NOTE these functions are not exported by the package, and are only usable within the package!
Object.defineProperty(exports, "__esModule", { value: true });
exports.billion = exports.millionInCents = exports.million = exports.thousand = void 0;
function thousand(prefix) {
    return prefix * 1000;
}
exports.thousand = thousand;
function million(prefix) {
    return prefix * 1000000;
}
exports.million = million;
function millionInCents(prefix) {
    return million(prefix * 100);
}
exports.millionInCents = millionInCents;
function billion(prefix) {
    return prefix * 1000000000;
}
exports.billion = billion;
